/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Mock_PendingInputs */

const en_cp_mock_pending = /** @type {(inputs: Cp_Mock_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phase 2 awaiting lecturer approval`)
};

const id_cp_mock_pending = /** @type {(inputs: Cp_Mock_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fase 2 menunggu persetujuan dosen`)
};

/**
* | output |
* | --- |
* | "Phase 2 awaiting lecturer approval" |
*
* @param {Cp_Mock_PendingInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_mock_pending = /** @type {((inputs?: Cp_Mock_PendingInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Mock_PendingInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_mock_pending(inputs)
	return en_cp_mock_pending(inputs)
});